export const mapStyles = [
  // modify style: https://mapstyle.withgoogle.com/
  {
    elementType: 'geometry',
    stylers: [],
  },
  {
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.text.fill',
    stylers: [],
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.text.fill',
    stylers: [],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [],
  },
  {
    featureType: 'road.local',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [],
  },
  {
    featureType: 'transit.line',
    elementType: 'geometry',
    stylers: [],
  },
  {
    featureType: 'transit.station',
    elementType: 'geometry',
    stylers: [],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [],
  },
];
